export const SAVE_COMPLETED_STEP_NAME = 'SAVE_COMPLETED_STEP_NAME';
export const SAVE_MAX_NAME = 'SAVE_MAX_NAME';
export const INCREMENT_MAX_STEP = 'INCREMENT_MAX_STEP';
export const INCREMENT_COMPLETED_STEP = 'INCREMENT_COMPLETED_STEP';

export function saveCompletedStepName(data) {
    return {
        type: SAVE_COMPLETED_STEP_NAME,
        data: data
    }
}

export function saveMaxStepName(data) {
    return {
        type: SAVE_MAX_NAME,
        data: data
    }
}

export function incrementMaxStep(data) {
    return {
        type: INCREMENT_MAX_STEP,
        data: data
    }
}

export function incrementCompletedStep(data) {
    return {
        type: INCREMENT_COMPLETED_STEP,
        data: data
    }
}

export function incrementSteps(data) {
    return dispatch => {
        dispatch(incrementMaxStep(data));
        dispatch(incrementCompletedStep(data));
    }
}